import { campaignMetrics, ChartDataResponse, DimensionInfo, MetricInfo } from "@api/common";
import { AppState, currentReportCampaign, toPieData } from "@store";
import { FetchingState } from "rd-redux-http";
import * as React from "react";
import { connect } from "react-redux";
import { ChartWithTable } from "./ChartWithTable";
import { filterDimensionsByData } from "./filterDimensionsByData";
import { Pie } from "./PieChart";

interface DemographicDeviceChartComponentProps {
    metrics: MetricInfo[];
    dimensions: DimensionInfo[];
    data: ChartDataResponse;
}

function DemographicDeviceChartComponent({ metrics, dimensions, data }: DemographicDeviceChartComponentProps) {
    return (
        <ChartWithTable title="Audience" subtitle="Device" data={data} metrics={metrics} dimensions={dimensions}>
            {metric => <Pie circleWidth={10} data={toPieData(data, metric, dimensions)} />}
        </ChartWithTable>
    );
}

export const DemographicDeviceChart = connect(
    (appState: AppState): DemographicDeviceChartComponentProps => {
        const campaign = currentReportCampaign(appState);
        const metrics = campaignMetrics(campaign ? campaign.unit : "CPM");

        const data = FetchingState.getDataOrDefault(appState.reports.chartData.osData, {
            metrics: [],
            dimensions: []
        });

        const devices = FetchingState.getDataOrDefault(appState.mappings.devices, []);
        const colors = ["#258CA1", "#F7B535", "#DB4A65", "#09A38C"];

        return {
            metrics,
            data,
            dimensions: filterDimensionsByData(
                devices.map<DimensionInfo>((d, index) => ({
                    color: colors[index],
                    dimension: d.type,
                    title: d.type,
                    icon: d.icon
                })),
                data
            )
        };
    }
)(DemographicDeviceChartComponent);
